import {Injectable} from '@angular/core';
import {SignalEntityQuery} from '../../state/signal-entity.store';
import {MiniQuestionFlowSessionStore, MiniQuestionFlowState} from './mini-question-flow-session.store';
import {FlowSessionDetails} from '../../models/underwriter.model';

@Injectable({providedIn: 'root'})
export class MiniQuestionFlowSessionQuery extends SignalEntityQuery<FlowSessionDetails, MiniQuestionFlowState>{
    constructor(protected store: MiniQuestionFlowSessionStore) {
        super(store);
    }
}
